import { AforoSimulator } from "./AforoSimulator";
import { AFORO_ZONES } from "./aforoConfig";

// Instancia única del simulador para toda la demo: el heatmap (vía el
// resolver del HeatmapAnimator), los labels y los botones leen de aquí.
export const aforoSimulator = new AforoSimulator(AFORO_ZONES);
